import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=75fe3272"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=75fe3272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryBreadcrumbs: require('/app/components/category/breadcrumbs.vue').default,Img: require('/app/components/img.vue').default,HeaterCalculatorCta: require('/app/components/heaterCalculatorCta.vue').default,ProductPrices: require('/app/components/product/prices.vue').default,ConfigurationsSkeleton: require('/app/components/configurationsSkeleton.vue').default,ProductAccessories: require('/app/components/product/accessories.vue').default,Empty: require('/app/components/empty.vue').default,Configurations: require('/app/components/configurations.vue').default,AnimatedNumber: require('/app/components/animatedNumber.vue').default,Quantity: require('/app/components/quantity.vue').default,Loader: require('/app/components/loader.vue').default,ProductWishlist: require('/app/components/product/wishlist.vue').default,ProductRequest: require('/app/components/product/request.vue').default,ProductFiles: require('/app/components/product/files.vue').default,ProductDetails: require('/app/components/product/details.vue').default,ProductPhotos: require('/app/components/product/photos.vue').default,ProductHeater: require('/app/components/product/heater.vue').default,ProductPartsList: require('/app/components/product/parts-list.vue').default})
